export default __webpack_public_path__ + "static/media/mc_rotor.9e1c430e.svg";